import { Component, Host, h, Element, Prop, Event, EventEmitter } from '@stencil/core'

@Component({
  tag: 'bam-logout-button',
})
export class BamLogoutButton {
  @Element() host: HTMLBamLogoutButtonElement

  @Prop() url?: string
  
  @Event() loggedOut: EventEmitter<boolean>


  handleClick = () => {
    this.loggedOut.emit(true)
    window.location.href = this.url
  }

  render() {
    return (
      <Host>
        <bal-button class="mt-medium" expanded onClick={this.handleClick} icon="logout">
          <slot></slot>
        </bal-button>
      </Host>
    )
  }
}
